import { reloadAnalyticsService } from './reloadAnalyticsService';

export function resetAnalyticsService() {
  reloadAnalyticsService();
  window.analytics?.reset();
}
